import styled from 'styled-components';

export const Container = styled.div`
    display: flex;
    justify-content: flex-start;
    overflow: auto;
    width: 100%;
    padding: 0.5rem 1rem 0.8rem 1rem;
    max-width: var(--max-width);
    overflow-y: visible;
    padding-top: 1rem;
    margin: 0 auto;
    > * {
        margin-right: 1rem;
    }

    ::-webkit-scrollbar {
        border-radius: 10px;
        width: 0.4rem;
        height: 0.4rem;
    }

    ::-webkit-scrollbar-thumb {
        border-radius: 10px;
        background: #bbb;
    }

    ::-webkit-scrollbar-thumb:hover {
        border-radius: 10px;
        background: #aaa;
    }

    @media screen and (max-width: 768px) {
        ::-webkit-scrollbar {
            border-radius: 10px;
            width: 0.1rem;
            height: 0.1rem;
        }
    }
`;
